export default __webpack_public_path__ + "static/gamification-3916919cf81f4424909d4b9c83184518.png";